(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/frejaeid/components/frejaeid-waiting.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/frejaeid/components/frejaeid-waiting.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.playerLoginReact.logger;
const Button = svs.ui.ReactButton;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const Loader = svs.components.ReactLoader.Loader;
const _svs$playerLoginReact = svs.playerLoginReact.constants,
  frejaeIdProgressStatus = _svs$playerLoginReact.frejaeIdProgressStatus,
  appWaitStatus = _svs$playerLoginReact.appWaitStatus,
  route = _svs$playerLoginReact.route;
const useFrejaeIdPollStatus = svs.playerLoginReact.frejaeid.useFrejaeIdPollStatus;
const frejaeIdBackendStatus = svs.playerLoginReact.store.playerloginreactactions.frejaeIdBackendStatus;
const _svs$playerLoginReact2 = svs.playerLoginReact.sharedComponents,
  useUrlHelper = _svs$playerLoginReact2.useUrlHelper,
  LoginQrCode = _svs$playerLoginReact2.LoginQrCode,
  AriaCountdownTimer = _svs$playerLoginReact2.AriaCountdownTimer,
  SelectEidMenu = _svs$playerLoginReact2.SelectEidMenu;

const FrejaeIdWaiting = _ref => {
  let _ref$isLogin = _ref.isLogin,
    isLogin = _ref$isLogin === void 0 ? true : _ref$isLogin,
    _ref$frejaeIdPollWait = _ref.frejaeIdPollWait,
    frejaeIdPollWait = _ref$frejaeIdPollWait === void 0 ? appWaitStatus.WAITING_QRCODE : _ref$frejaeIdPollWait;
  const history = useHistory();
  const dispatch = ReactRedux.useDispatch();
  const frejaeIdAuthRef = ReactRedux.useSelector(state => state.playerloginreact.authRef);
  const baseUrl = ReactRedux.useSelector(state => state.playerloginreact.baseUrl);
  const isStandardMobile = ReactRedux.useSelector(state => state.playerloginreact.isStandardMobile);
  const _useFrejaeIdPollStatu = useFrejaeIdPollStatus(isLogin, frejaeIdAuthRef),
    appUrl = _useFrejaeIdPollStatu.appUrl,
    qrCode = _useFrejaeIdPollStatu.qrCode,
    backendStatus = _useFrejaeIdPollStatu.backendStatus,
    cancelBackendPoll = _useFrejaeIdPollStatu.cancelBackendPoll,
    isLastQrRetry = _useFrejaeIdPollStatu.isLastQrRetry,
    TIME_TO_POLL_TIMEOUT = _useFrejaeIdPollStatu.TIME_TO_POLL_TIMEOUT;
  const _React$useState = React.useState(frejaeIdProgressStatus.BEFORE_POLL),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    waitStatus = _React$useState2[0],
    setWaitStatus = _React$useState2[1];
  const _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    shouldShowScanText = _React$useState4[0],
    setShouldShowScanText = _React$useState4[1];
  const _useUrlHelper = useUrlHelper(),
    navigateToCancelUrl = _useUrlHelper.navigateToCancelUrl;
  const TIME_REMAINING_WHEN_TO_DISPLAY_ARIA = TIME_TO_POLL_TIMEOUT - 40; 
  logger.debug('**** app url', appUrl);

  React.useEffect(() => {
    dispatch(frejaeIdBackendStatus(backendStatus));
    setWaitStatus(backendStatus);
  }, [backendStatus]);
  React.useEffect(() => {
    logger.debug('appurl:', appUrl);
    if (appUrl && appUrl.length > 5 && frejaeIdPollWait === appWaitStatus.WAITING_APP) {
      logger.debug('**** open appurl:', appUrl);
      svs.utils.url.navigate(appUrl);
    }
  }, [appUrl]);
  React.useEffect(() => {
    if (isLastQrRetry) {
      const btn = document.getElementById('retryButton');
      if (btn) {
        btn.focus();
      }
    }
  }, [isLastQrRetry]);
  const handleTimerDone = React.useCallback(() => {
    setShouldShowScanText(false);
  }, []);
  const onCancelClick = async () => {
    await cancelBackendPoll();
    if (isStandardMobile) {
      const loginPath = baseUrl;
      logger.debug("**** Doing hard load of ".concat(isLogin ? 'login' : 'registrate'));
      if (isLogin) {
        svs.utils.url.navigate(loginPath + route.LOGIN_FREJAEID_START_ROUTE);
      } else {
        svs.utils.url.navigate(loginPath + route.REGISTRATE_FREJAEID_ROUTE);
      }
    } else if (frejaeIdPollWait === appWaitStatus.WAITING_QRCODE) {
      navigateToCancelUrl();
    } else if (isLogin) {
      history.push(route.LOGIN_FREJAEID_START_ROUTE);
    } else {
      history.push(route.REGISTRATE_FREJAEID_ROUTE);
    }
  };
  const onRetry = () => {
    cancelBackendPoll();
    history.push(isLogin ? route.LOGIN_FREJAEID_START_ROUTE : route.REGISTRATE_FREJAEID_START_ROUTE);
  };
  const handleLoginOnOtherDevice = () => {
    svs.components.analytics.trackEvent({
      category: 'Users',
      action: 'Login Mobile Fallback',
      opt_label: 'frejaeid'
    });
    history.push(isLogin ? route.LOGIN_FREJAEID_POLL_QR_ROUTE : route.REGISTRATE_FREJAEID_POLL_QR_ROUTE);
  };
  logger.debug('frejaeidwaitstatus', waitStatus);
  logger.debug('frejaeidpollwait', frejaeIdPollWait);
  return React.createElement("div", {
    className: "fc-navy"
  }, (waitStatus === frejaeIdProgressStatus.BEFORE_POLL || waitStatus === frejaeIdProgressStatus.WAITING_APP) && frejaeIdPollWait === appWaitStatus.WAITING_APP && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-top-4 margin-top-3 margin-bottom-1"
  }, React.createElement("p", null, "F\xF6rs\xF6ker starta Freja eID-appen")), isStandardMobile && React.createElement("div", {
    className: "padding-bottom-1"
  }, React.createElement(Button, {
    block: true,
    onClick: handleLoginOnOtherDevice,
    size: 300,
    transparent: true
  }, "Logga in p\xE5 en annan enhet"))), (waitStatus === frejaeIdProgressStatus.BEFORE_POLL || waitStatus === frejaeIdProgressStatus.SHOWING_QRCODE || waitStatus === frejaeIdProgressStatus.ERROR_POLL || waitStatus === frejaeIdProgressStatus.CLIENT_TIMEOUT) && frejaeIdPollWait === appWaitStatus.WAITING_QRCODE && React.createElement(React.Fragment, null, !isStandardMobile && React.createElement(SelectEidMenu, {
    isLogin: isLogin
  }), React.createElement(LoginQrCode, {
    errorMessage: "Inloggningen tog f\xF6r l\xE5ng tid.",
    isError: waitStatus === frejaeIdProgressStatus.CLIENT_TIMEOUT,
    qrCode: qrCode
  }, React.createElement(React.Fragment, null, React.createElement("div", {
    className: "padding-bottom-1"
  }, React.createElement(AriaCountdownTimer, {
    onDone: handleTimerDone,
    showTime: TIME_REMAINING_WHEN_TO_DISPLAY_ARIA,
    startTime: TIME_TO_POLL_TIMEOUT
  })), !isStandardMobile && isLastQrRetry && React.createElement(Button, {
    block: true,
    className: "margin-bottom-2",
    id: "retryButton",
    onClick: onRetry,
    tabIndex: 0,
    transparent: true
  }, "F\xF6rl\xE4ng tid"), shouldShowScanText && React.createElement("p", {
    className: "padding-am-bottom-1"
  }, "Skanna QR-koden med Freja eID-appen")))), (waitStatus === frejaeIdProgressStatus.SHOWING_SPINNER || waitStatus === frejaeIdProgressStatus.NEW_CUSTOMER || waitStatus === frejaeIdProgressStatus.RETAIL_CUSTOMER || waitStatus === frejaeIdProgressStatus.REACTIVATED_CUSTOMER || waitStatus === frejaeIdProgressStatus.ONLINE_CUSTOMER) && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "login-react-margin-top-8"
  }, waitStatus === frejaeIdProgressStatus.SHOWING_SPINNER ? 'Väntar på identifiering i app' : 'Loggar in...'), React.createElement("div", {
    className: "login-react-margin-top-7 login-react-loader-view-container"
  }, React.createElement(Loader, {
    size: 300
  }))), React.createElement("div", null, React.createElement(Button, {
    block: true,
    onClick: onCancelClick,
    size: 300,
    transparent: true
  }, "Avbryt")));
};
svs.playerLoginReact.frejaeid.components.FrejaeIdWaiting = FrejaeIdWaiting;

 })(window);